import angular from 'angular';
import { react2angular } from 'react2angular';
import ListingViewAsset from './ListingViewAsset';

angular
  .module('bb.listing_view')
  .component('listingViewAsset', react2angular(ListingViewAsset, ['asset']));
